import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import {
    changeChatView,
    changeSelectedRoom,
    fetchRoomMention,
    markAsReadChat,
    selectAllChatRoom,
    selectChatLoading,
} from "../../../slices/chat";
import MentionNotification from "./mentionNotification";
import ChatModule from "../../Chat";
import { useSocketInstance } from "../../../../context/SocketContext";
import NoDataCard from "../../../components/NoDataCard";
import { notify } from "../../../utils/methods/notification";

// 🟢 Simple Skeleton Loader
const MentionSkeleton = () => {
    return (
        <div className="p-4 border-b border-gray-200 animate-pulse">
            <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-300 rounded w-1/2"></div>
        </div>
    );
};

const Tags = ({ renderTags }) => {
    const isLoading = useSelector(selectChatLoading);
    const { socketInstance, setMentions, mentions } = useSocketInstance();
    const dispatch = useDispatch();
    const [page, setPage] = useState(1);
    const LoginData = useSelector((state) => state.loginData);
    
    const role_slug = LoginData.role_slug;
    const [hasMore, setHasMore] = useState(true);
    const allChatRoom = useSelector(selectAllChatRoom);
    const [openChat, setOpenChat] = useState(false);

    const setChatView = async (view, chatRoom) => {
        await dispatch(changeChatView(view));
        await dispatch(changeSelectedRoom(chatRoom));
    };

    // Socket listener
    useEffect(() => {
        if (!socketInstance) return;

        const handleReceiveTags = (data) => {
            setMentions((prevMentions) => {
                const alreadyExists = prevMentions.some(
                    (m) => m.id === data.id
                );
                if (!alreadyExists) {
                    return [data, ...prevMentions];
                }
                return prevMentions;
            });
        };

        socketInstance.on("mentioned_in_message", handleReceiveTags);
        return () => {
            socketInstance.off("mentioned_in_message", handleReceiveTags);
        };
    }, [socketInstance]);
    const handleMention = async (clickedMention) => {
        try {
            const chatRoom = allChatRoom?.find(
                (room) => String(room.id) === String(clickedMention?.chat_room_id)
            );

            if (!chatRoom) {
                notify.error("Chat room not found for this mention.");
                return;
            }

            const res = await dispatch(
                markAsReadChat({id:clickedMention?.id, room_id:clickedMention?.chat_room_id})
            ).unwrap();

            if (res?.success) {
                setMentions((prev) =>
                    prev.filter((m) => m.id !== clickedMention.id)
                );

                setChatView("chat", chatRoom);
                setOpenChat(true);

                if (res?.data?.message) notify.success(res.data.message);
            } else {
                notify.error(res?.message ?? "Failed to mark as read.");
            }
        } catch (err) {
            console.error(err);
            notify.error(
                err?.message ?? "Something went wrong while marking as read."
            );
        }
    };

    const loadMentions = async () => {
        try {
            const response = await dispatch(
                fetchRoomMention({ page, limit: 10 })
            ).unwrap();
            const newMentions = response?.data || [];
            if(page == 1)
            setMentions(newMentions);
             else
            setMentions((prev) => [...prev, ...newMentions]);
            setPage((prev) => prev + 1);

            if (newMentions.length < 10) {
                setHasMore(false);
            }
        } catch (err) {
            console.error("Failed to load mentions:", err);
            setHasMore(false);
        }
    };

    useEffect(() => {
        if (renderTags > 0) {
            setMentions([]);
        }
    }, [renderTags]);

    useEffect(() => {
        loadMentions();
    }, []);

    return (
        <div>
            <InfiniteScroll
                dataLength={mentions.length}
                next={loadMentions}
                hasMore={hasMore}
                loader={
                    <>
                        {[...Array(3)].map((_, idx) => (
                            <MentionSkeleton key={idx} />
                        ))}
                    </>
                }
            >
                {mentions?.length === 0 && !isLoading ? (
                    <NoDataCard />
                ) : (
                    mentions.map((mention) => (
                        <MentionNotification
                            key={mention.id}
                            mention={mention}
                            handleMention={handleMention}
                        />
                    ))
                )}
            </InfiniteScroll>

{role_slug !== "project-manager" && (
            <ChatModule disableAdd={true} preOpen={openChat} setOpenChat={setOpenChat} />
      )} 
        </div>
    );
};

export default Tags;
